import React from 'react';

import { Checkbox } from '@mui/material';

import TrplErrorAlertIcon from './TrplErrorAlertIcon';
import FuzzyVal from './FuzzyVal';

import SetDeleteTrplBtns from './SetDeleteTrplBtns';
import CreateTrplBtn from './CreateTrplBtn';
import { shouldShowTrplAsEdited } from '../../../utils';
import MandatoryAlertIcon from './MandatoryAlertIcon';
import { savedTrplColor } from '../../../constants';

export default ({
  rst,
  trpls,
  type,
  setTrpl,
  classes,
  groupId,
  constant,
  isVirtual,
  tidsChains,
  ancestorId,
  deletedTids,
  loadingTids,
  hideSetDelete,
  isAnotherNode,
  setLoadingTids,
  onRstValueEdit,
  removeTrplValue,
  disableTrplEditing,
  showMandatoryAlert,
}) => {

  return (
    <div>
      {trpls.map((trpl, trplIndex) => (
        <div key={`${rst.title}.${trplIndex}`} className={`${classes.flex} ${trplIndex === 0 ? '' : classes.mt5}`}>
          <div
            key={trplIndex}
            className={classes.fw}
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <div className={`${classes.checkboxTrplContainer} ${!trpl.tid && trpl.unsaved ? classes.unsavedNewTrpl : ''}`}
              style={{
                background: shouldShowTrplAsEdited(trpl)
                  ? '#d3fff4' //'#ddfd7d'//
                  : !trpl.tid && showMandatoryAlert
                    ? '#FFD3B5'
                    : isVirtual
                      ? '#def0f5'
                      : trpl.tid
                        ? savedTrplColor//'#ddeed59e'//'#f2eee1'
                        : ''
              }}
            >
              <Checkbox
                margin="none"
                color="default"
                disabled={constant || disableTrplEditing}
                classes={{
                  root: classes.trplCheckbox,
                }}
                value={trpl.val}
                checked={trpl && trpl.val ? trpl.val.toString() === 'true' : false}
                onChange={(e) => {
                  onRstValueEdit(rst, e.target.checked, trplIndex, ancestorId, tidsChains && trpl.tid && tidsChains[trpl.tid]);
                }}
              />
              {rst && rst.renderer ?
                <div style={{ color: '4c4c4c' }}>
                  {trpl && trpl.val ? (rst.renderer.hasOwnProperty('true')
                    ? <span className={`${classes.mr5} ${classes.nowrap}`} style={{ marginLeft: '2px' }}>
                        {rst.renderer.true === 'rst_title' ? rst.rst_title : rst.renderer.true}
                      </span>
                    : null)
                      : (!trpl.val && rst.renderer.hasOwnProperty('false')
                      ? <span className={`${classes.mr5} ${classes.nowrap}`} style={{ marginLeft: '2px' }}>
                          {rst.renderer.false === 'rst_title'
                            ? rst.rst_title
                            : rst.renderer.false === `not 'rst_title'`
                              ? `not ${rst.rst_title}`
                              : rst.renderer.false
                            }
                        </span>
                        : null)
                  }
                </div>
              : null}
            </div>

            {trpl.val_fuzzy ?
              <div className={`${classes.fillAvailable} ${classes.relative}`} style={{ height: '24px' }}>
                <FuzzyVal
                  top={'-9px'}
                  left={'-15px'}
                  classes={classes}
                  value={trpl.val_fuzzy}
                />
              </div>
            : null}

            <TrplErrorAlertIcon trpl={trpl} />
            {!trpl.tid && showMandatoryAlert && <MandatoryAlertIcon />}
          </div>

          {hideSetDelete ? null : trpl.tid ?
            <SetDeleteTrplBtns
              rst={rst}
              type={type}
              trpl={trpl}
              groupId={groupId}
              classes={classes}
              setTrpl={setTrpl}
              trplIndex={trplIndex}
              ancestorId={ancestorId}
              isAnotherNode={isAnotherNode}
              loadingTids={loadingTids}
              removeTrplValue={removeTrplValue}
              setLoadingTids={setLoadingTids}
              constant={constant || disableTrplEditing}
            />
            :
            <CreateTrplBtn
              rst={rst}
              trpl={trpl}
              classes={classes}
              setTrpl={setTrpl}
              trplIndex={trplIndex}
              ancestorId={ancestorId}
              loadingTids={loadingTids}
              deletedTids={deletedTids}
              isAnotherNode={isAnotherNode}
              setLoadingTids={setLoadingTids}
              disableTrplEditing={disableTrplEditing}
            />
          }
        </div>
      ))}
    </div>
  );
};
